(function () {
  'use strict';

  var KEY = 'bc:wishlist';
  var META_KEY = 'bc:wishlist:meta';

  // Price gate (16. august 2026): B2B status is decided SERVER-SIDE in Liquid
  // and exposed as data-bc-b2b="true" on <html> (layout/theme.liquid), where
  // customer.b2b? is authoritative. Never re-derive it in JS from login state
  // or from anything in localStorage — a browser that once belonged to an
  // approved clinic still holds saved favourites with prices in them. Missing
  // attribute is treated as NOT B2B (fail closed).
  function canShowPrices() {
    return document.documentElement.getAttribute('data-bc-b2b') === 'true';
  }

  // Keys that may carry an amount on a stored wishlist meta record.
  var PRICE_KEYS = ['price', 'compare', 'compare_at', 'compareAt', 'compare_at_price', 'price_min', 'price_max'];

  function hasPriceField(meta) {
    if (!meta || typeof meta !== 'object') return false;
    for (var i = 0; i < PRICE_KEYS.length; i++) {
      if (Object.prototype.hasOwnProperty.call(meta, PRICE_KEYS[i])) return true;
    }
    return false;
  }

  // Returns a copy of a meta record without any price fields. Defensive on
  // purpose: records written by older theme versions have different shapes and
  // many have no price fields at all. Id, url, title, image and vendor are kept
  // so the wishlist keeps working.
  function stripPrice(meta) {
    if (!meta || typeof meta !== 'object') return {};
    var clean = {};
    for (var key in meta) {
      if (!Object.prototype.hasOwnProperty.call(meta, key)) continue;
      if (PRICE_KEYS.indexOf(key) !== -1) continue;
      clean[key] = meta[key];
    }
    return clean;
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function write(ids) {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) {}
  }

  function readMeta() {
    try {
      var raw = localStorage.getItem(META_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      if (canShowPrices()) return parsed;

      // Price gate: strip the amounts out of the stored records for a non-B2B
      // visitor and write the cleaned version back, so old prices do not stay
      // behind on the machine.
      var cleaned = {};
      var changed = false;
      for (var id in parsed) {
        if (!Object.prototype.hasOwnProperty.call(parsed, id)) continue;
        if (hasPriceField(parsed[id])) changed = true;
        cleaned[id] = stripPrice(parsed[id]);
      }
      if (changed) writeMeta(cleaned);
      return cleaned;
    } catch (e) {
      return {};
    }
  }

  function writeMeta(meta) {
    try { localStorage.setItem(META_KEY, JSON.stringify(meta)); } catch (e) {}
  }

  function announce(ids) {
    document.dispatchEvent(new CustomEvent('bc:wishlist:updated', {
      detail: { count: ids.length, ids: ids.slice() }
    }));
  }

  var BCWishlist = {
    has:     function (id) { return read().indexOf(String(id)) !== -1; },
    getAll:  function ()   { return read(); },
    count:   function ()   { return read().length; },
    getMeta: function (id) { return readMeta()[String(id)] || null; },
    getAllWithMeta: function () {
      var ids = read(), meta = readMeta();
      return ids.map(function (id) { return Object.assign({ id: id }, meta[id] || {}); });
    },
    add: function (id, meta) {
      var ids = read(), sid = String(id);
      if (ids.indexOf(sid) === -1) { ids.push(sid); write(ids); }
      if (meta) {
        var m = readMeta();
        // Price gate: an amount is never persisted for a non-B2B visitor.
        m[sid] = canShowPrices() ? meta : stripPrice(meta);
        writeMeta(m);
      }
      announce(ids);
      return ids;
    },
    remove: function (id) {
      var ids = read(), sid = String(id), i = ids.indexOf(sid);
      if (i !== -1) { ids.splice(i, 1); write(ids); announce(ids); }
      return ids;
    },
    toggle: function (id, meta) {
      return this.has(id) ? this.remove(id) : this.add(id, meta);
    }
  };

  window.BCWishlist = BCWishlist;

  function syncButtons(root) {
    var ids = read();
    var scope = root || document;
    var cardBtns = scope.querySelectorAll('[data-bc-card-wishlist][data-bc-card-id]');
    for (var i = 0; i < cardBtns.length; i++) {
      var on = ids.indexOf(String(cardBtns[i].getAttribute('data-bc-card-id'))) !== -1;
      cardBtns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var pdpBtns = scope.querySelectorAll('[data-wishlist="toggle"][data-id]');
    for (var j = 0; j < pdpBtns.length; j++) {
      var active = ids.indexOf(String(pdpBtns[j].getAttribute('data-id'))) !== -1;
      pdpBtns[j].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { announce(read()); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Runs readMeta() once on every page load, which is what scrubs any
    // leftover prices out of localStorage for a non-B2B visitor.
    readMeta();
    announce(read());
    syncButtons(document);
  });
  document.addEventListener('shopify:section:load', function (e) { syncButtons(e.target); });
  document.addEventListener('bc:wishlist:updated', function () { syncButtons(document); });
})();
